import moment from "moment-timezone";

const timezoneOptions = moment.tz.names().map((tz) => {
  const offset = moment.tz(tz).utcOffset() / 60;
  const gmt = `GMT${offset >= 0 ? `+${offset}` : offset}`;
  const parts = tz.split("/");
  const continent = parts[0];
  const city = parts[1] || "";
  return {
    label: `(${gmt}) ${city}/${continent}`,
    value: tz,
  };
});

export { timezoneOptions };
